module.exports = __webpack_public_path__ + "static/4_2_recommendation_ES-96c30b36db9f48cae95ccdab2a450644.svg";